import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-translate';
import './image-drop-zone.css';
import * as S from './styles';

class ImageDropZone extends Component {
  static propTypes = {
    anySize: PropTypes.bool,
    showButton: PropTypes.bool,
    showDeleteButton: PropTypes.bool,
    imageWidth: PropTypes.number,
    imageHeight: PropTypes.number,
    imageIndex: PropTypes.number,
    fontSize: PropTypes.number,
    imageDefault: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    imagePicked: PropTypes.func,
    imageDeleted: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      image: null,
      error: '',
      over: false,
      deleted: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    // if deleted the don't reset to image default
    if (state.deleted) {
      return null;
    }

    // set image default
    if (!state.image && props.imageDefault) {
      return { image: props.imageDefault };
    }
    return null;
  }

  handleFile = (event) => {
    const { imagePicked } = this.props;

    const image = URL.createObjectURL(event.target.files[0]);
    const file = event.target.files[0];
    this.setState({
      file,
      image,
    });

    imagePicked({
      index: this.props.imageIndex,
      file,
      image,
    });
  };

  deleteFile = () => {
    const { imageDeleted, imagePicked } = this.props;

    imagePicked({
      index: this.props.imageIndex,
      file: null,
      image: null,
    });
    if (imageDeleted) {
      imageDeleted(this.props);
    }

    this.setState({
      image: null,
      deleted: true,
    });
  };

  onDragOver = () => {
    event.preventDefault();
  };

  onDragEnter = () => {
    this.setState({
      over: true,
    });
  };

  onDragLeave = () => {
    this.setState({
      over: false,
    });
  };

  onDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    const image = URL.createObjectURL(file);

    this.setState({
      image,
      over: false,
    });

    this.props.imagePicked({
      index: this.props.imageIndex,
      file,
      image,
    });
  };

  onLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    const { imageWidth, imageHeight, anySize, t } = this.props;

    if (
      !anySize &&
      ((imageWidth && imageWidth !== naturalWidth) ||
        (imageHeight && imageHeight !== naturalHeight))
    ) {
      this.setState({
        error: `${t('ERROR-MESSAGE')} ${naturalWidth}x${naturalHeight}`,
        image: null,
      });
    } else {
      this.setState({
        error: '',
      });
    }
  };

  render() {
    const { image, error, over } = this.state;
    const {
      width,
      height,
      imageWidth,
      imageHeight,
      anySize,
      showButton,
      showDeleteButton,
      fontSize,
      t,
    } = this.props;

    return (
      <div>
        <div
          onDrop={this.onDrop}
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDragEnter={this.onDragEnter}
          style={{
            width: `${width}px`,
            height: `${height}px`,
            backgroundImage: `url(${image || ''})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            ...S.style.frame,
            ...(over ? S.style.enter : S.style.leave),
          }}
        >
          {image !== null ? (
            <img onLoad={this.onLoad} src={image} alt={image} width={0} height={0} />
          ) : (
            <div style={{ pointerEvents: 'none' }}>
              <div style={{ ...S.style.label, fontSize: fontSize ? `${fontSize}px` : '34px' }}>
                {!anySize ? (
                  <div>
                    {imageWidth} x{imageHeight}
                  </div>
                ) : (
                  'Drop Here'
                )}
                <div>{error}</div>
              </div>
            </div>
          )}
        </div>

        <div style={{ display: 'flex' }}>
          {showButton && (
            <div className="button-container">
              <label className="button">
                {t('UPLOAD-BUTTON')}
                <input
                  style={{ display: 'none' }}
                  type="file"
                  value=""
                  onChange={this.handleFile}
                />
              </label>
            </div>
          )}

          {showDeleteButton && (
            <div className="button-container">
              <label className="button">
                {t('DELETE-BUTTON')}
                <button style={{ display: 'none' }} type="button" onClick={this.deleteFile} />
              </label>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default translate('ImageDropZone')(ImageDropZone);
